import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { valdiatePage, processStrWithSpaceAndSpecalChars, processPassword, getSession, processNum, processEmail, validateEmail } from '../../global';
import { getIsUserCreationValid, createZaUser } from '../../services/usermanagementservice';
import { setLoading } from '../../redux/appSlice';
import { ButtonPrimary } from '../../components/formelements';
import { getAccountBranches } from "../../services/bookingservice";

const UserCreation = () => {
    const dispatch = useDispatch();
    const { userInfo, accounts } = useSelector(state => state.appData);

    const history = useHistory();

    const d = {
        loggenInUser: getSession("userId"),
        userId: '',
        accountNo: '',
        branchCode: '',
        locationName: '',
        locationAddress: '',
        branchName: '',
        email:'',
        loginId: userInfo?.id
    }

    useEffect(() => {
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        if (!valdiatePage('/createuser')) {
            history.push('/login');
        }
        return () => {
            source.cancel('Operation canceled by the user.');
        }
    }, []);

    const [data, setData] = useState(d);
    const [validRequest, setValidRequest] = useState(false);
    const [successfullySubmitted, setSuccessfullySubmitted] = useState(false);
    const [branches, setBranches] = useState([]);


    const updateData = (key, val) => { setData(prev => { return { ...prev, [key]: val } }); }

    const onSave = async () => {

        if (!data.userId) {
            alert('Inter User Id');
            return;
        }

        if (!data.accountNo) {
            alert('Inter Account');
            return;
        }

        if (!data.branchCode) {
            alert('Inter Branch');
            return;
        }

        if (!data.email || data.email.trim() == '') {
            alert('Enter Email');
            return;
        }

        if(validateEmail(data.email)) {
            alert('Incorrect Email Format');
            return;
        }

        if (!data.locationName || data.locationName.trim() === '') {
            alert('Enter Location Name');
            return;
        }

        if (!data.locationAddress || data.locationAddress.trim() === '') {
            alert('Enter Location Address');
            return;
        }

        try {

            dispatch(setLoading({ data: true }));
            const rs2 = await getIsUserCreationValid(data.loggenInUser, data.userId, data.accountNo, data.branchCode);
            if (rs2.sts == 0) {
                console.log(data);
                const rs = await createZaUser({
                    accountNo: data.accountNo,
                    branchCode: data.branchCode,
                    locationAddress: data.locationAddress,
                    locationName: data.locationName,
                    userId: data.userId,
                    email: data.email,
                    loginId: data.loginId
                });
                alert(rs.msg);
                if (rs.ok === true) {
                    setSuccessfullySubmitted(true)
                }
            } else {
                alert(rs2.msg);
            }

        } catch (e) {
            alert(e.message)
        } finally {
            dispatch(setLoading({ data: false }));

        }
    }

    const getuserInfo = async (e) => {
        if (!data.userId) {
            alert('Inter User Id');
            return;
        }

        if (!data.accountNo) {
            alert('Inter Account');
            return;
        }

        if (!data.branchCode) {
            alert('Inter Branch');
            return;
        }

        dispatch(setLoading({ data: true }));
        const rs = await getIsUserCreationValid(data.loggenInUser, data.userId, data.accountNo, data.branchCode);
        dispatch(setLoading({ data: false }));
        alert(rs.msg);
        if (rs.sts == 0) {
            setValidRequest(true)
        } else {
            setValidRequest(false)
        }
    }

    const getAccountBranch = async (e) => {
        const accountNo = e.target.value;
        if (!accountNo) {
            alert('Select Account No');
            return;
        }
        updateData('branchCode', '')
        dispatch(setLoading({ data: true }));
        if (accountNo)
            await getAccountBranches(accountNo).then(rs => {
                if (rs && rs.ok) {
                    setBranches(rs.data);
                }
                else {
                    setBranches([]);
                }
            })

        dispatch(setLoading({ data: false }));

    }

    const onBack = () => {
        setSuccessfullySubmitted(false)
        setValidRequest(false)
        setData(d);
    }


    return userInfo && <section className="section">
        <div className="section-header">
            <h1>Create User</h1>
        </div>
        {
            successfullySubmitted ? <div className="card" style={{ padding: 10 }}>
                <div className="row mt-2">
                    <div className="col-12 text-center p-2">
                        <h2 style={{
                            fontSize: '20px',
                        }}>User Info</h2>
                    </div>

                    <div className="col-md-2 col-sm-12 pb-2 border-bottom border-top"><b>User Id</b></div>
                    <div className="col-md-2 col-sm-12 pb-2 border-bottom border-top border-left"><b>Account No</b></div>
                    <div className="col-md-2 col-sm-12 pb-2 border-bottom border-top border-left"><b>Branch</b></div>
                    <div className="col-md-2 col-sm-12 pb-2 border-bottom border-top border-left"><b>Email</b></div>
                    <div className="col-md-2 col-sm-12 pb-2 border-bottom border-top border-left"><b>Location Name</b></div>
                    <div className="col-md-2 col-sm-12 pb-2 border-bottom border-top border-left"><b>Location Address</b></div>

                    <div className="col-md-2 col-sm-12 pb-2 border-bottom">{data?.userId}</div>

                    <div className="col-md-2 col-sm-12 pb-2 border-bottom border-left">{data.accountNo}</div>

                    <div className="col-md-2 col-sm-12 pb-2 border-bottom border-left">{data.branchName}</div>

                    <div className="col-md-2 col-sm-12 pb-2 border-bottom border-left">{data.email}</div>

                    <div className="col-md-2 col-sm-12 pb-2 border-bottom border-left">{data.locationName}</div>

                    <div className="col-md-2 col-sm-12 pb-2 border-bottom border-left">{data.locationAddress}</div>
                </div>

                <div className="row mt-2">
                    <div className="col-12" style={{ textAlign: 'right' }}>
                        <ButtonPrimary text={'Back'} onClick={onBack} />
                    </div>
                </div>
            </div> : <div className="card" style={{ padding: 10 }}>
                <div className="row">
                    <div className="col-lg-3 col-sm-12">
                        <label>New User Id</label>
                        <input type="text" className="form-control" value={data.userId} onInput={processPassword} maxLength={49} onChange={e => updateData('userId', e.target.value)} />
                    </div>

                    <div className="col-lg-3 col-sm-12">
                        <label>Account No</label>
                        <input type="text" className="form-control" value={data.accountNo} onBlur={getAccountBranch} onInput={processStrWithSpaceAndSpecalChars} maxLength={49} onChange={e => updateData('accountNo', e.target.value)} />
                    </div>

                    <div className="col-lg-3 col-sm-12">

                        <label>Branches</label>
                        <select className="form-select" value={data.branchCode} style={{
                            height: '42px',
                            padding: '7.5px 13px'
                        }} onChange={e => {
                            const branch = e.target[e.target.selectedIndex].getAttribute('data-branch');
                            updateData('branchName', branch)
                            updateData('branchCode', e.target.value)
                        }}>
                            <option value="">Select Branch</option>
                            {
                                branches.map((x, index) => <option key={index} value={x.value} data-branch={x.text}>{x.text}</option>)
                            }
                        </select>

                    </div>

                    <div className="col-lg-2" style={{ display: 'flex', alignItems: 'flex-end' }}>
                        <button type="button" className="btn btn-primary" style={{
                            height: '42px',
                            padding: '7.5px 13px'
                        }} disabled={false} onClick={getuserInfo}>User Available</button>
                    </div>

                    <div className="row mt-3">
                        <div className="col-lg-3 col-sm-12">
                            <label>Email</label>
                            <input type="text" className="form-control" value={data.email} onInput={processEmail} maxLength={89} onChange={e => updateData('email', e.target.value)} />
                        </div>
                        <div className="col-lg-3 col-sm-12">
                            <label>Location Name</label>
                            <input type="text" className="form-control" value={data.locationName} onInput={processStrWithSpaceAndSpecalChars} maxLength={49} onChange={e => updateData('locationName', e.target.value)} />
                        </div>
                        <div className="col-lg-12 col-sm-12">
                            <label>Location Address</label>
                            <textarea className="form-control" value={data.locationAddress} onInput={processStrWithSpaceAndSpecalChars} maxLength={255} onChange={e => updateData('locationAddress', e.target.value)}></textarea>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col" style={{ textAlign: 'right' }}>
                            <button type="button" className="btn btn-primary" style={{
                                height: '42px',
                                padding: '7.5px 13px'
                            }} onClick={onSave}>Save</button>
                        </div>
                    </div>
                </div>
            </div>
        }

    </section>
}

export default UserCreation;
